<div class="document-editor">
  <div class="document-editor__toolbar"></div>
  <div class="document-editor__editable-container">
    <div id="content" class="document-editor__editable"></div>
  </div>
</div>
